import { useMemo } from 'react';
import { usePhoneService } from "../phone-service/PhoneService.js";
export function useFormattedPhoneNumber(input) {
  var {
    format,
    country,
    fallback = ''
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var phoneService = usePhoneService();
  return useMemo(() => {
    if (phoneService.checkPossibility(input) !== 'is-possible') {
      return fallback;
    }
    return phoneService.format(input, {
      format,
      country,
      fallback
    });
  }, [phoneService, input, format, country, fallback]);
}